// created by liujunyang 2016-07-18

import vars from 'vars'
import navData from 'nav-data'
import request from 'request2'
import JsEncrypt from "jsencrypt";

var htmlTags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "math",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rb",
    "rp",
    "rt",
    "rtc",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "slot",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "svg",
    "table",
    "tbody",
    "td",
    "template",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr"
];
var basic = /\s?<!doctype html>|(<html\b[^>]*>|<body\b[^>]*>|<x-[^>]+>)+/i;
var full = new RegExp(htmlTags.map(function (el) {
    return '<' + el + '\\b[^>]*>';
}).join('|'), 'i');

export function isHtml(str) {
    if (basic.test(str)) {
        return true;
    }

    return full.test(str);
};


/**
 * 根据路由确定导航条的展示数据
 * @description 解决刷新页面或浏览器前进后退的时候不能触发toggle函数切换导航展示的问题，
 *              切换路由的时候执行
 * @param  {String} name 页面名
 */
export function resetNavbar(name) {
    let navlist = navData.navlist
    for (let i = 0; i < navlist.length; i++) {
        if(navlist[i].rel == name){
            navData.lv1 = i
            return;
        }else{
            for (let j = 0; j < navlist[i].children.list.length; j++) {
                if(navlist[i].children.list[j].rel == name){
                    navData.lv1 = i
                    navlist[i].children.activeindex = j
                    return;
                }
            };
        }
    };
}

/**
 * 秒数转换
 * @param  {Number} second 秒
 * @return {Object}        countday    天
 *                         countHour   时
 *                         countMinute 分
 *                         countSecond 秒
 */
export function splitSecond(second) {
    var countday = second % (3600 * 24)
    var counthour = countday % (3600)
    return {
        countDay: Math.floor(second / (3600 * 24)),
        countHour: Math.floor(countday / (3600)),
        countMinute: counthour % 60 ? Math.floor(counthour / 60) : Math.floor(counthour / 60) - 1,
        countSecond: counthour % 60 ? counthour % 60 : 60
    }
}

/**
 * 格式化url
 * @param  {[String]} url
 * @return {[Object]}
 */
export function parseUrl(url = window.location.href) {
    var a = document.createElement('a')
    a.href = url
    return {
        source: url,
        protocol: a.protocol.replace(':', ''),
        host: a.hostname,
        port: a.port,
        query: a.search,
        params: (function() {
            var ret = {},
                seg = a.search.replace(/^\?/, '').split('&'),
                len = seg.length,
                i = 0,
                s
            for (; i < len; i++) {
                if (!seg[i]) {
                    continue
                }
                s = seg[i].split('=')
                ret[s[0]] = s[1]
            }
            return ret
        })(),
        file: (a.pathname.match(/\/([^\/?#]+)$/i) || [null, ''])[1],
        hash: a.hash.replace('#', ''),
        path: a.pathname.replace(/^([^\/])/, '/$1'),
        relative: (a.href.match(/tps?:\/\/[^\/]+(.+)/) || [null, ''])[1],
        segments: a.pathname.replace(/^\//, '').split('/')
    }
}


/**
 * 页面跳转
 * @param  {String} page   页面名
 * @param  {String} params 页面路由参数
 */
export function pageTo(page = 'index', params = '', reload = false) {
    if (page === 404 || page === 500) {
        window.location.href = vars['error'] + '?' + 'c=' + page
    }
    if (page in vars) {
        window.location.href = vars[page] + (reload ? '?t=' + (+new Date()) : '') + '#!' + params
    }
}

/**
 * 设置字体禁止放大缩小 android手机字体缩放
 * @param
 */
export function setSize() {
    if (typeof WeixinJSBridge === 'undefined') {
        document.addEventListener('WeixinJSBridgeReady', function (e) {
            setTimeout(function(){
                typeof WeixinJSBridge !== 'undefined' && WeixinJSBridge.invoke('setFontSizeCallback',{'fontSize':0}, function(res) {
                });

//                 WeixinJSBridge.invoke("setNavigationBarColor", {
//                   color: "#8d0809"
//                 }, function(res) {
//                    console.info(res)
//                 })
            },0);

        });
    } else {
        setTimeout(function(){
            typeof WeixinJSBridge !== 'undefined' && WeixinJSBridge.invoke('setFontSizeCallback',{'fontSize':0}, function(res) {
            });

//             WeixinJSBridge.invoke("setNavigationBarColor", {
//               color: "#8d0809"
//             }, function(res) {
//                console.info(res)
//             })
        },0);
    }
}

/**
 * 检测是否是https
 * @param
 */
export function initProtocal() {
    let url = location.href;

    // 是否是网页版
    let pubSub = window.parent && window.parent.PubSub || null;
    if(pubSub) {
        return this;
    }

    // 检测是否是http
    if(location.protocol === 'http:') {
        if(location.host.indexOf('yuketang') !== -1 || location.host.indexOf('ykt.io') !== -1) {
            url = url.replace('http:', 'https:').replace('ykt.io', 'www.yuketang.cn');

            location.replace(url);
        }
    }
}

export function pagereload() {
    //修改IOS返回页面不刷新问题。
    $(function () {
        var isPageHide = false;
        window.addEventListener('pageshow', function () {
            if (isPageHide) {
                window.location.reload();
            }
        });
        window.addEventListener('pagehide', function () {
            isPageHide = true;
        });
    })
}

/**
 * 检测是否支持本地storage
 * @param
 */
export function isSupported(storage) {
  try {
    const key = "__some_random_key_you_are_not_going_to_use__";
    storage.setItem(key, key);
    storage.removeItem(key);
    return true;
  } catch (e) {
    // const QUOTA_EXCEEDED_ERR_CODE = 22;
    if (e.code === 22) {
      storage.clear();
    }

    return false;
  }
}


export function getPlatformKey() {
  let key = 'rain';
  let host = {
    'www.yuketang.cn': 'rain',
    'b.yuketang.cn': 'thunder',
    'pro.yuketang.cn': 'thu',
    'yuketang.tsinghua.edu.cn': 'thu',
    'ykt2-envning.skilltraining.cn': 'thu',
    'ykt2-env-example.skilltraining.cn': 'thu',
    'changjiang.yuketang.cn': 'changjiang',
    'g.yuketang.cn': 'g',
    'huanghe.yuketang.cn': 'huanghe',
    'hhtest.yuketang.cn': 'hhtest',
    'pro.xuetangonline.com': 'protest',
    'protest.xuetangonline.com': 'protest',
    'pre-apple-ykt.xuetangonline.com': 'pre-apple-ykt',
    'rain.gdufemooc.cn': 'gc',
    'ykt-dev.xuetangonline.com': 'aliOss',
    // 镜泊雨课堂
    'ykt-envning.rainclassroom.com': 'envning',
    // 鸣泉雨课堂
    'ykt-env-example.rainclassroom.com': 'env-example',
    //K12
    'www.yudou.cn': 'yudou',
    'jcjy2edu.rainclassroom.com': 'yudou',

    // 清华继教学院定制需求 单独判断该学校使用的域名
    'online1.yuketang.cn': 'huanghe',
    'www.itsinghua.com': 'huanghe',
    'home.itsinghua.com': 'huanghe',
    'localhost:8080': 'localhost'
  }

  key = host[location.host] || 'rain';

  return key;
}

/**
 * 字符串字符数量 汉字等是两个字符
 * @param str
 */
export function getLength(str) {
    let result = 0;
    let length = str.length;
    while (length--) {
        if (/^[\u0000-\u00ff]$/.test(str.charAt(length))) {
        result += 1;
        } else {
        result += 2;
        }
    }

    return result;
}

/**
 * 字符串截取 英文*2
 * @param str maxLength
 */
export function substr(str, maxLength) {
    let re = new RegExp("^[a-zA-Z]|[0-9]+$");
    let length = str.length;
    let result = 0;
    let index = 0;

    for(let i = 0; i < str.length; i++){
        if (/^[\u0000-\u00ff]$/.test(str.charAt(i))) {
        result += 1;
        } else {
        result += 2;
        }
        if(result >= maxLength * 2){
        index = i + 1
        break
        }
    }

    /**
     * 如果是开头英文最后是中文的正则检测为true
     * 此时字符串截取就出错了
     * 所以改为上面的方法

        if (re.test(str)) {
        maxLength = maxLength * 2;
        }
        *
        */

    return str.substr(0, index);
}

$.extend($, {

    isAndroid: function(){
        var u = navigator.userAgent.toLowerCase();
        return u.indexOf('android') > -1 || u.indexOf('linux') > -1; //android终端或者uc浏览器
    },

    isIOS: function(){
        var u = navigator.userAgent;
        return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    },
    setWXConfig: function(){
        typeof wx !== 'undefined' && $.ajax({ type: 'POST', url: '/v/course_meta/weixin_index_parameter', data: JSON.stringify({ url: location.href}), dataType: 'json',
            success: function(res){
                let data = res.data.js_config;
                // 微信分享配置
                wx.config({
                    debug: false,
                    appId: data.appId,
                    timestamp: data.timestamp,
                    nonceStr: data.nonceStr,
                    signature: data.signature,
                    jsApiList: [ 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ','onMenuShareWeibo', 'onMenuShareQZone', 'showMenuItems',
                    'translateVoice', 'startRecord', 'stopRecord', 'onVoiceRecordEnd', 'playVoice', 'onVoicePlayEnd', 'pauseVoice','stopVoice', 'uploadVoice',
                    'downloadVoice', 'chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'getNetworkType',  'scanQRCode',  'chooseWXPay',
                    'openProductSpecificView',  'addCard',  'chooseCard', 'openCard' ]
                });
            }, error: function(xhr, type){}
        });
    },
    resetTitle: function(title){
        var $body = $('body');
        document.title = title;
        // hack在微信等webview中无法修改document.title的情况
        if($.isIOS()){
            var $iframe = $('<iframe src="/vue_images/images/favicon.ico" style="width:1px; height:1px;"></iframe>');
            $iframe.on('load',function() {
                setTimeout(function() {
                    $iframe.off('load').remove();
                }, 0);
            }).appendTo($body);
        }
    },
    timeStr2Hour: function(str){
        // 从时间字符串转化为消耗的小时的数值
        // 输入：08:52:09
        // 输出：8.869166666666667
        var hms = str.split(':')
        return ((+hms[0]) + (+hms[1]/60) + (+hms[2]/3600))
    },
    timeStrArr2HourArr: function(strArr){
        // 从时间字符串，无视日期，取得其从0点开始过了几个小时
        // 输入：['2016-11-25 08:52:09', '2016-11-26 09:32:09', '2016-11-27 08:22:09', '2016-11-28 08:42:09']
        // 输出：[8.869166666666667,9.535833333333333,8.369166666666667,8.702499999999999]
        var stampList = []
        for (var i = 0; i < strArr.length; i++) {
          var hms = strArr[i].split(' ')[1]
          var hour = $.timeStr2Hour(hms)

          // 产品设定有效打卡时间，如果超过10点就设置为10点，早于5点设置为5点
          hour < 5 && (hour = 5)
          hour > 10 && (hour = 10)
          // 把10点作为Y轴0点，把5点作为Y轴高点的话，要的起始是距离10点的距离
          stampList.push(10-hour)
        }
        return stampList
    },
    timeStrArr2DateArr: function(strArr, noyear){
        // 从时间字符串，取得日期
        // 输入：['2016-11-25 08:52:09', '2016-11-26 09:32:09', '2016-11-27 08:22:09', '2016-11-28 08:42:09']
        // 输出：['2016-11-25', '2016-11-26', '2016-11-27', '2016-11-28']
        // 如果noyear为true，输出中就不带年份：['11-25', '11-26', '11-27', '11-28']
        var stampList = []
        for (var i = 0; i < strArr.length; i++) {
          var yyyymmdd = strArr[i].split(' ')[0]
          var _date = noyear ? yyyymmdd.replace('2016-', '').replace('2017-', '') : yyyymmdd

          stampList.push(_date)
        }
        return stampList
    },
    getBytesLength : function(str){
        ///<summary>获得字符串实际长度，中文2，英文1</summary>
        ///<param name="str">要获得长度的字符串</param>
        var realLength = 0, len = str.length, charCode = -1;
        for (var i = 0; i < len; i++) {
            charCode = str.charCodeAt(i);
            if (charCode >= 0 && charCode <= 128)
                realLength += 1;
            else
                realLength += 2;
        }
        return realLength;
    },
    urlMock(url){
        // TODO: 这里用于测试测试环境接口，暂时不走这个判断
        if (process.env.NODE_ENV !== 'production' && 0) {
            return 'http://apimock.xuetangx.com/mock/115/' + url
        }
        return "/" + url;
    }
})


$.fn.transform = function(s_css){
    this.css("transform",s_css);
    this.css("-webkit-transform",s_css);
    this.css("-moz-transform",s_css);
}

// 动态加载js
export function loadScript(src, attributes) {
    return new Promise((resolve, reject) => {
      let scriptNode = document.createElement("script");
      scriptNode.setAttribute("type", "text/javascript");
      scriptNode.setAttribute("src", src);
      if(attributes && attributes.length) {
        attributes.forEach(item => {
            scriptNode[item] = true
        })
      }
      document.body.appendChild(scriptNode);

      scriptNode.onload = (evt) => {
        resolve(evt);
      }

      scriptNode.onerror = (evt)=>{
        reject('加载失败');
      }
    });
  }

export function encrypt(value) {
    // 密码加密
    let publicKey = '-----BEGIN PUBLIC KEY-----MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCQBaPX7crEH6/jS4hRD7lZrsFRIdfwEhH30onFnrnWxiRATzP9WEneXJEZHopmzudkNS5bDp51SCnBUGGgfL/sUUrlrhV2xnTSe1jRl924ejV5rkVkiii85jp9G8eJrJN6klHs0PfYfp4EVJ8688qpi5iETtg+q4ITocyEyD1+7wIDAQAB-----END PUBLIC KEY-----'
    let encryptor = new JsEncrypt();
    encryptor.setPublicKey(publicKey);
    return encryptor.encrypt(value);
}

export function configPretreat (conf) {
    let result = {};
    try {
        result = typeof conf === "string" ? JSON.parse(conf) : conf;
        result = typeof result === 'string' ? JSON.parse(result) : result;
    } catch (error) {
        result = {};
    }
    return result || {};
}

export function presentationCanShowSlides (presentation, slides) {
    const { config, conf } = presentation || {};
    const list = isHelpfulArray(slides) ? slides : [];
    const confData = configPretreat(conf || config);
    const { show_presentation, hide_slides } = confData || {};
    if(show_presentation === 'all_not') {
        return [];
    }
    if(show_presentation === 'part') {
        const hideSlides = isHelpfulArray(hide_slides) ? hide_slides : [];
        return list.filter(item => {
            const { id, lessonSlideID } = item || {};
            return !hideSlides.includes(id || lessonSlideID);
        });
    }
    return list;
}

// 获取一堂课多个 presentation 集合竞出的config
// key: 新旧接口字段名称不一样： conf config
export function getMutiCoursewaresConfig (presentations, key = 'conf') {
    const showStatus = [];
    if (presentations instanceof Array) {
        if (presentations.length === 1) {
            return configPretreat(presentations[0][key]);
        }
        for (let i = 0, len = presentations.length; i < len; i++) {
            const item = presentations[i] || {};
            const conf = configPretreat(item[key]);
            const { show_presentation: show } = conf;
            if (
                show === 'film' || show === 'part'
                || show === 'all' && showStatus.includes('all_not')
                || show === 'all_not' && showStatus.includes('all')
            ) {
                return {
                    show_presentation: 'part',
                };
            } else {
                showStatus.push(show);
            }
        }
        return {
            show_presentation: showStatus.includes('all_not') ? 'all_not' : 'all',
        };
    }
    return {
        show_presentation: 'all'
    };
}

// 给习题列表等单项添加是否可见字段
export function setItemNotVisible (list, presentations, pid) {
    const confs = {};
    if (!Array.isArray(list)) {
        return [];
    }
    if (Array.isArray(presentations)) {
        presentations.forEach(item => {
            const { conf, config, id} = item || {};
            const result = configPretreat(conf || config);
            const { show_presentation, hide_slides } = result;
            if (id) {
                confs[id] = {
                    show_presentation: show_presentation || 'all',
                    hide_slides: hide_slides || [],
                }
            } else if (presentations.length === 1) {
                confs[pid] = {
                    show_presentation: show_presentation || 'all',
                    hide_slides: hide_slides || [],
                }
            }
        });
    }
    return list.map(item => {
        let { presentation_id, presentationId, data, problemId, id, slideId, slide_id } = item || {};
        const { lessonSlideID, SlideID } = data || {};
        if (item.problem) {
            presentationId = item.problem.presentationId;
        }
        if (SlideID) {
            slideId = SlideID;
        }
        const tartget = confs[presentation_id || presentationId || pid];
        const { show_presentation, hide_slides } = tartget || {};
        if(tartget) {
            if(show_presentation === 'all_not') {
                return Object.assign(item, {
                    notVisible: true,
                })
            } else if (show_presentation === 'part') {
                const slides = hide_slides || [];
                const notVisible = slides.includes(lessonSlideID || problemId || id || slideId || slide_id);
                return Object.assign(item, {
                    notVisible,
                });
            }
        }
        return item;
    });
}

export function setItemNotVisibleOld (list, config) {
    let { show_presentation, hide_slides } = config;
    hide_slides = isHelpfulArray(hide_slides) ? hide_slides : [];
    return list.map(item => {
        let { lessonSlideID } = item || {};
        if(show_presentation === 'all_not') {
            return Object.assign(item, {
                notVisible: true,
            })
        } else if (show_presentation === 'part') {
            const notVisible = hide_slides.includes(lessonSlideID);
            return Object.assign(item, {
                notVisible,
            });
        }
        return item;
    });
}


// 判断是不是一个有效的数组
export function isHelpfulArray (list) {
    return list instanceof Array && list.length;
}


// 清除sessionStorage数据
export function removeSessionStorageData(key) {
    sessionStorage.removeItem(key)
}

// 是否腾讯会议应用内
export function isTMWebview() {
  try {
    const ua = window.navigator.userAgent;
    return ua.includes('app/tencent_wemeet');
  } catch(error) {
    return false;
  }
}

// 日期格式转换 2020-09-09 12:00
export function formatTimeUniversal(timestamp) {
  if (!timestamp) return '';

  // 兼容秒/毫秒时间戳
  if(`${timestamp}`.length === 10) {
    timestamp = timestamp * 1000;
  }
  const time = new Date(timestamp);
  const date = time.toLocaleDateString('en-CA');
  // const time = new Date(timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
  const hour = time.getHours() > 9 ? time.getHours() : '0' + time.getHours();
  const mins = time.getMinutes() > 9 ? time.getMinutes() : '0' + time.getMinutes();
  return `${date} ${hour}:${mins}`;
}

// 检查是否是旧版本微信
// https://developers.weixin.qq.com/miniprogram/dev/framework/client-lib/version.html
// https://weixin.qq.com/cgi-bin/readtemplate?t=weixin_faq_list
export function isOldWeChat() {
  let res = false;
  const wxVersion = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i);
  if (wxVersion && wxVersion[1]) {
    const v = parseInt(wxVersion[1].split('.')[0]);
    if (v && v < 8) {
      res = true;
    }
  }

  return res;
}


// 将Hex颜色值转成RGB模式
export function hexToRgba(hex, alpha) {
    // 移除前导井号
    hex = hex.replace(/^#?/, "");

    // 计算RGB值
    var r;
    var g;
    var b;

    // 判断颜色值的长度，并计算相应的RGB值
    switch (hex.length) {
      case 3:
        r = parseInt(hex.substr(0, 1) + hex.substr(0, 1), 16);
        g = parseInt(hex.substr(1, 1) + hex.substr(1, 1), 16);
        b = parseInt(hex.substr(2, 1) + hex.substr(2, 1), 16);
        break;
      case 6:
        r = parseInt(hex.substr(0, 2), 16);
        g = parseInt(hex.substr(2, 2), 16);
        b = parseInt(hex.substr(4, 2), 16);
        break;
      default:
        throw new Error('Invalid hex color code');
    }

    // 返回RGBA字符串
    return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
}



// WEBPACK FOOTER //
// ./src/util/utils.js